import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';
import { X } from 'lucide-react';
import { useFlowStore } from '../../store/flowStore';

// Aresta padrão: linha base + "fluxo andando" (dashes em movimento) + botão excluir ao selecionar.
export function AnimatedEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  label,
  selected,
}: EdgeProps) {
  const deleteEdge = useFlowStore((s) => s.deleteEdge);
  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const accent = selected ? '#E11019' : '#9AA8B8';

  return (
    <>
      {/* base sólida discreta */}
      <BaseEdge
        id={id}
        path={path}
        markerEnd={markerEnd}
        style={{ stroke: selected ? '#E11019' : '#C2CCD8', strokeWidth: selected ? 2.5 : 2 }}
      />
      {/* fluxo animado por cima */}
      <path d={path} fill="none" stroke={accent} strokeWidth={2} className="edge-flow" style={{ pointerEvents: 'none' }} />

      <EdgeLabelRenderer>
        {label && (
          <div
            style={{ transform: `translate(-50%, -150%) translate(${labelX}px, ${labelY}px)` }}
            className="pointer-events-none absolute rounded-full border border-line bg-white px-2 py-0.5 text-[10px] font-medium text-slate shadow-sm"
          >
            {String(label)}
          </div>
        )}
        {selected && (
          <div
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
            className="edge-action nodrag nopan absolute"
          >
            <button
              onClick={() => deleteEdge(id)}
              className="flex h-6 w-6 items-center justify-center rounded-full border border-line bg-white text-slate shadow-soft transition-colors hover:border-danger hover:bg-danger hover:text-white"
              aria-label="Excluir conexão"
              title="Excluir conexão"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
}
